import React from 'react';
import {
  trackWindowScroll,
  LazyLoadComponent,
} from 'react-lazy-load-image-component';

let storedUseIntersectionObserver = null;

export const LazyLoadingProvider = trackWindowScroll(({
  children,
  useIntersectionObserver,
}) => {
  storedUseIntersectionObserver = useIntersectionObserver;
  return children;
});

export const LazyLoadingComponent = ({ children }) => (
  <LazyLoadComponent useIntersectionObserver={storedUseIntersectionObserver} delayMethod="throttle">
    {children}
  </LazyLoadComponent>
);
